import {
  Grid,
  Paper,
  Typography,
  OutlinedInput,
  Button,
  Input,
  FormControl,
  InputLabel,
  InputAdornment,
  makeStyles,
} from '@material-ui/core';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux';
import React, { useState, useEffect } from 'react';
import RoundButton from '../../../../Common/RoundButton';
import { useHistory } from 'react-router-dom';
import Curerncy from '../../../../utils/assests/currency.svg';
import { getAddMoneyValue } from '../../InvestFund/investFundAction';
import { AppState } from '../../../../store/rootReducer';
import { getPortfolioSummaryRequest, setTenureValue } from '../dashboardAction';
import AddMoneyImg from '../../../../utils/assests/add-money.png';
import ErrorMessage from '../../../../Common/ErrorMessage';
const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiFilledInput-root': {
      background: 'rgb(232, 241, 250)',
    },
    '& .Mui-focused': {
      color: 'tomato',
      fontWeight: 'bold',
    },
  },
}));

const Addmoney = ({
  confirmInvestment,
  formikRef,
  enterKeyPress,
  amount,
  setAmount,
  setError,
  error,
  amountError,
}: any) => {
  let history = useHistory();
  let dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPortfolioSummaryRequest());
    dispatch(setTenureValue(6));
  }, []);

  const { dashboardSummary } = useSelector(
    (state: AppState) => state.dashboard
  );
  // const [remainingInvestmentAmount, setRemainingInvestmentAmount] = useState<any>(null);
  // useEffect(() => {
  //   console.log("dashboardSummary", dashboardSummary)
  //   if(dashboardSummary !== undefined && dashboardSummary !== null){
  //     console.log("dashboardSummary", dashboardSummary);
  //     debugger
  //     const investedAmount = dashboardSummary?.data.TotalPrincipalInvestment;
  //     const remainingAmount = 1000000 - investedAmount;
  //     console.log(remainingAmount);
  //     if(remainingAmount > 0){
  //         setRemainingInvestmentAmount(remainingAmount)
  //     }
  //   }
  // },[dashboardSummary]);

  // useEffect(() => {
  //   if(amount !== ''){
  //   console.log(remainingInvestmentAmount);
  //   debugger;
  //   const remaining = remainingInvestmentAmount - parseInt(amount);
  //   console.log(remaining)
  //   debugger;
  //   setRemainingInvestmentAmount(remaining);
  //   }
  // },[amount]);
  const classes = useStyles();

  const addInvestAmount = (e: any) => {
    const { value } = e.target;
    dispatch(getAddMoneyValue(value));
    if (value > 1000000) {
      setError(true);
      setAmount(value);
    } else {
      setAmount(value);
      setError(false);
    }
  };

  const [setReturnValue, returnValue] = useState({
    id: 6,
    expectedReturns: 9,
  });

  const [returnData, setReturnData] = useState([
    { id: 6, expectedReturns: 9, isSelected: true },
    { id: 12, expectedReturns: 9.25, isSelected: false },
    { id: 36, expectedReturns: 9.1, isSelected: false },
  ]);

  const onClickMonth = (month: number) => {
    const expReturnValue = [...returnData];
    const returnValueData = expReturnValue.find((r: any) => r.id === month);
    for (let i = 0; i < expReturnValue.length; i++) {
      if (expReturnValue[i].id === month) expReturnValue[i].isSelected = true;
      else expReturnValue[i].isSelected = false;
    }
    if (returnValueData) {
      if (returnValueData?.isSelected) {
        dispatch(setTenureValue(returnValueData?.id));
        returnValue(returnValueData);
      }
    }
    setReturnData(expReturnValue);
    return true;
  };

  return (
    <>
      <Box className='cardHeadingNew'>
        <Typography variant='h1'>Add money</Typography>
      </Box>
      <Grid>
        <Box className='addMoney'>
          <Box className='addMoneyBox'>
            <FormControl fullWidth variant='standard'>
              <label>Enter investment amount</label>
              <Input
                type='number'
                id='investment_amount'
                innerRef={formikRef}
                inputProps={{
                  min: 0,
                  max: 1000000,
                  style: {
                    textAlign: 'center',
                    color: '#000066',
                    fontWeight: 'bold',
                    fontSize: '22px',
                    border: 'none',
                    marginBottom: '0',
                  },
                }}
                onKeyPress={enterKeyPress}
                onKeyDown={(e) =>
                  ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()
                }
                // startAdornment={
                //   <InputAdornment position='start'>
                //     <img src={Curerncy} alt='currency logo' width={18} />
                //   </InputAdornment>
                // }
                className={classes.root}
                value={amount}
                name='amount'
                onChange={(e) => addInvestAmount(e)}
                autoFocus
                autoComplete='off'
              />
              <Box style={{ display: 'flex' }}>
                {amount !== '' ? (
                    <Typography
                      align='left'
                      component='span'
                      className={amount > 1000000 ? 'inputInfoText' : ''}
                    >
                      max. investment <span>₹ 10,00,000</span>
                    </Typography>
                ) : null}
              </Box>
              {error && <p className='errorMsg'>Invalid amount</p>}
              {amountError && <ErrorMessage text='Please enter amount' />}
            </FormControl>
          </Box>
        </Box>
        <RoundButton
          title='Continue'
          onClick={confirmInvestment}
          // disable={amount === null || amount < 10000 || error || amount > 1000000 }
        />

        <Box className='circleImage'>
          <img src={AddMoneyImg} alt='' />
          <Typography>
            Each transaction is <br />
            completely secure
          </Typography>
        </Box>
      </Grid>
    </>
  );
};

export default Addmoney;
